import { SidenavComponent } from "./sidenav.component";
export interface ISidenavEvent {
	isToggled: boolean;
	self: SidenavComponent;
}
